import { useMemo } from 'react';
import { AlertTriangle } from 'lucide-react';

import { useOrigins } from '@components/features/Compliance/queries';
import { usePageProtectionEnabled } from '@components/features/Compliance/status';

import css from './styles.module.css';

export function ComplianceCount() {
  const { data } = useOrigins();
  const enabled = usePageProtectionEnabled();

  const count = useMemo(() => {
    let count = 0;
    if (!data) return count;

    for (const origin of data.origins) {
      count += origin.newScriptAlertsCount + origin.newHeaderAlertsCount;
    }
    return count;
  }, [data]);

  if (!enabled) return null;
  if (!count) return null;

  return (
    <span className={css.complianceCount}>
      <AlertTriangle className={css.icon} />
      <span>{count}</span>
    </span>
  );
}
